var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { RemoveScroll } from 'react-remove-scroll';
export { ReactFocusOn as FocusOn } from './component';
export { AutoFocusInside, MoveFocusInside, InFocusGuard } from 'react-focus-lock';
export var classNames = __assign({}, RemoveScroll.classNames);
